
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/urge-surfing",
      function () {
        return require("private-next-pages/urge-surfing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/urge-surfing"])
      });
    }
  